import React from 'react';

/**
 * 我的发票图标
 */
export const MyInvoiceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <clipPath id="master_svg0_58_3737">
        <rect x="0" y="0" width="24" height="24" rx="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#master_svg0_58_3737)">
      <path
        d="M21.75,7.5L2.25,7.5C1.4249999500000001,7.5,0.75,6.8250003,0.75,6L0.75,2.25C0.75,1.4249999500000001,1.4249999500000001,0.75,2.25,0.75L21.75,0.75C22.575001,0.75,23.25,1.4249999500000001,23.25,2.25L23.25,6C23.25,6.8250003,22.575001,7.5,21.75,7.5Z"
        fill="currentColor"
        fillOpacity="0.44999998807907104"
      />
      <path
        d="M20.25,6L3.75,6C3.33749986,6,3,5.6625001,3,5.25L3,3.75C3,3.33749986,3.33749986,3,3.75,3L20.25,3C20.662498,3,21,3.33749986,21,3.75L21,5.25C21,5.6625001,20.662498,6,20.25,6Z"
        fill="#FFFFFF"
        fillOpacity="1"
      />
      <path
        d="M19.057499999999997,22.731001L16.282499,20.650501C15.96068,20.408773,15.524548,20.385944,15.179249,20.592751L12.4814987,22.587002C12.1851673,22.763998,11.8155804,22.763998,11.519249,22.587002L8.8214989,20.592001C8.4755869,20.385149,8.038880299999999,20.408274,7.7167482,20.650501L4.9627482999999994,22.71525C4.73609376,22.886314,4.43231821,22.91486,4.17776442,22.789013C3.92321026,22.663162,3.761445165,22.404461,3.7597482204,22.120501L3.75,21L3.75,4.3252501500000005C3.75,4.00874984,4.00874984,3.75,4.3244998500000005,3.75L19.675501,3.75C19.992001,3.75,20.250002,4.00874984,20.250002,4.3252501500000005L20.250002,21L20.241001,22.14525C20.238047,22.424015,20.078728,22.677481,19.828812,22.801014C19.578896,22.924545,19.280769,22.897194,19.057503,22.730251"
        fill="currentColor"
        fillOpacity="0.8500000238418579"
      />
      <path
        d="M15.75,9.75L8.25,9.75C7.83749986,9.75,7.5,9.412500099999999,7.5,9C7.5,8.58749986,7.83749986,8.25,8.25,8.25L15.75,8.25C16.1624994,8.25,16.5,8.58749986,16.5,9C16.5,9.412500099999999,16.1624994,9.75,15.75,9.75ZM15.75,15.75L8.25,15.75C7.83749986,15.75,7.5,15.4124994,7.5,15C7.5,14.5875006,7.83749986,14.25,8.25,14.25L15.75,14.25C16.1624994,14.25,16.5,14.5875006,16.5,15C16.5,15.4124994,16.1624994,15.75,15.75,15.75Z"
        fill="#FFFFFF"
        fillOpacity="1"
      />
    </g>
  </svg>
);

